import * as React from 'react';

export function SvgJiraNeutral(props: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11514_33)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
          fill="white"
        />
        <path
          d="M8.97313 15.5029H7.62057C5.58062 15.5029 4.11719 14.263 4.11719 12.4475H11.39C11.767 12.4475 12.0109 12.7131 12.0109 13.0895V20.3517C10.1927 20.3517 8.97313 18.8904 8.97313 16.8535V15.5029ZM12.5652 11.8939H11.2126C9.17269 11.8939 7.70926 10.6762 7.70926 8.86065H14.9821C15.359 8.86065 15.6251 9.1042 15.6251 9.48059V16.7428C13.8069 16.7428 12.5652 15.2815 12.5652 13.2445V11.8939ZM16.1794 8.30713H14.8269C12.7869 8.30713 11.3235 7.06725 11.3235 5.25171H18.5963C18.9733 5.25171 19.2172 5.5174 19.2172 5.87165V13.1338C17.399 13.1338 16.1794 11.6725 16.1794 9.63558V8.30713Z"
          fill="#1868DB"
        />
      </g>
      <defs>
        <clipPath id="clip0_11514_33">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
